import { memo, useEffect } from 'react'
import { useAuth } from 'react-oidc-context'
import { Route, Routes } from 'react-router-dom'

import { AdminRouter } from '../adminPages/AdminRouter'
import { useUser } from '../hooks/storeHooks/useUserState'
import { useNativeBridgeAuth } from '../hooks/useNativeBridgeAuth'
import { isSafari } from '../utils/browserDetect'
import UserRouter from './UserRouter'

const Router: React.FC = memo(() => {
  const { fetchUser } = useUser()
  const { isAuthenticated } = useAuth()
  useNativeBridgeAuth()

  useEffect(() => {
    if (isAuthenticated) {
      void fetchUser()
    }
  }, [isAuthenticated])

  useEffect(() => {
    if (isSafari()) {
      document.documentElement.classList.add('safari')
    }
  }, [])

  return (
    <Routes>
      <Route path="/admin/*" element={<AdminRouter />} />
      <Route path="/*" element={<UserRouter />} />
    </Routes>
  )
})

export { Router }
